module.exports = __webpack_public_path__ + "static/media/papercane.46baff48.webp";